import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';

import { createFormParticipant, loadForm } from '../../../store/participantService';
import { loadUser } from '../../../store/userService';

import CreateUCD603Form from './formUCD603/CreateUCD603Form';
import CreateUCD604Form from './formUCD604/CreateUCD604Form';
import { themeJson } from './FormTheme';

const ConductForm = ({ formId, adviser, onClose }) => {
    const dispatch = useDispatch();

    //LOCAL STATE
    const [surveyModel, setSurveyModel] = useState(new Model('{}'));
    const [surveyComplete, setSurveyComplete] = useState(false);
    const [createUCD603Pdf, setCreateUCD603Pdf] = useState(false);
    const [createUCD604Pdf, setCreateUCD604Pdf] = useState(false);

    //STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const currentForm = useSelector((state) => state.entities.participantService.currentForm);
    const formStatusDetails = useSelector(
        (state) => state.entities.directusService.formStatusDetails
    );

    // USE EFFECTS
    useEffect(() => {
        dispatch(loadForm(formId));
    }, [formId]);

    useEffect(() => {
        if (currentParticipant.userId) {
            dispatch(loadUser(currentParticipant.userId));
        }
    }, [currentParticipant]);

    useEffect(() => {
        if (Object.keys(currentForm).length < 1) return;
        const model = new Model(currentForm.data);
        model.applyTheme(themeJson);
        model.showQuestionNumbers = true;
        setSurveyModel(model);
    }, [currentForm]);

    useEffect(() => {
        if (surveyComplete) {
            if (currentForm.name.includes('UCD604')) setCreateUCD604Pdf(true);
            else if (currentForm.name.includes('603')) setCreateUCD603Pdf(true);
            else {
                const payload = {
                    participantId: currentParticipant.id,
                    statusId: formStatusDetails.find((el) => el.name === 'Open')?.id || '',
                    pdfName: currentForm.name,
                    formId: currentForm.id,
                    data: surveyModel.data
                };
                dispatch(createFormParticipant(payload));
                onFormExit();
            }
        }
    }, [surveyComplete]);

    // EVENT HANDLERS
    const onSurveyComplete = () => setSurveyComplete(true);

    const onComplete = () => {
        createUCD603Pdf && setCreateUCD603Pdf(false);
        createUCD604Pdf && setCreateUCD604Pdf(false);
        onFormExit();
    };

    const onFormExit = () => {
        setSurveyComplete(false);
        onClose();
    };

    // RENDER
    return (
        <div>
            <Survey model={surveyModel} onComplete={onSurveyComplete} />

            {createUCD603Pdf && (
                <CreateUCD603Form
                    currentForm={currentForm}
                    surveyModelData={surveyModel.data}
                    participantsAdviser={adviser}
                    onClose={onComplete}
                />
            )}

            {createUCD604Pdf && (
                <CreateUCD604Form
                    currentForm={currentForm}
                    surveyModelData={surveyModel.data}
                    participantsAdviser={adviser}
                    onClose={onComplete}
                />
            )}
        </div>
    );
};

ConductForm.propTypes = {
    formId: PropTypes.string.isRequired,
    adviser: PropTypes.object,
    onClose: PropTypes.func,
    roles: PropTypes.arrayOf(PropTypes.string)
};

export default ConductForm;
